import z from "zod";

/**
 * Schema for creating a product
 */
export const createProductSchema = z.object({
  id: z.number().nullable().optional(),
  code: z.number({ message: "Código é obrigatório" }),
  name: z.string({ message: "Nome é obrigatório" }).min(1, "Nome não pode estar vazio"),
  group: z.number({ message: "Grupo é obrigatório" }),
  ncmcode: z.string({ message: "Código NCM é obrigatório" })
});
